import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IndustryDropdown from '@adsk-smart-components/industry';
import CompanyInput from '@adsk-smart-components/company';
import Role from '@adsk-smart-components/role';
import { filteredArray } from '../helpers';
import Link from '@mui/material/Link';
import SuccessFields from './SuccessFields';
import FieldSkeleton from './skeletons/FieldSkeleton';
import LabelSkeleton from './skeletons/LabelSkeleton';
import Skeleton from '@mui/material/Skeleton';
import ConditionalRender from './common/ConditionalRender';
interface IRoleInput {
  roleId: string;
  roleName: string;
}

type FCProps = {
  env: string;
  description: string;
  locale: string;
  companyValue: string;
  industryValue: Array<string>;
  roleValue: IRoleInput;
  onValueChange: Function;
  isSuccess: boolean;
  successTitle: string;
  successMessage: string | React.ReactNode;
  linkText: string;
  linkUrl: string;
  industryLabel: string;
  roleLabel: string;
  companyLabel: string;
  industryProps?: object;
  roleProps?: object;
  companyProps?: object;
  isLoading?: boolean;
  isDataParsed?: boolean; // required to avoid the MUI uncontrolled error for role and industry
  isCompanyHidden?: boolean;
};

const Fields = ({
  env,
  description,
  locale,
  companyValue = '',
  industryValue = [],
  roleValue,
  onValueChange,
  isSuccess,
  successTitle,
  successMessage,
  linkText,
  linkUrl,
  industryLabel,
  roleLabel,
  companyLabel,
  industryProps,
  roleProps,
  companyProps,
  isLoading = false,
  isDataParsed = false,
  isCompanyHidden = false,
}: FCProps): JSX.Element =>
  !isSuccess ? (
    <>
      <Box pb={4}>
        <ConditionalRender
          isLoading={isLoading}
          skeletonComponent={
            <Skeleton
              variant="rectangular"
              width="100%"
              height={24}
              sx={{ marginBottom: '24px' }}
            />
          }
          component={
            <Typography variant="body1" fontWeight="medium">
              {description}
            </Typography>
          }
        />
      </Box>
      <Box pb={4}>
        <ConditionalRender
          isLoading={!isDataParsed}
          skeletonComponent={<FieldSkeleton />}
          component={
            <IndustryDropdown
              locale={locale}
              currentSelectedValues={industryValue}
              onSelectedIndustriesChanged={(e: any) =>
                onValueChange(
                  filteredArray(e, ['__typename', 'segmentName']),
                  'industryValue'
                )
              }
              labelText={industryLabel}
              maxLimit={3}
              environment={env}
              {...industryProps}
            />
          }
        />
      </Box>
      <Box pb={4}>
        <ConditionalRender
          isLoading={!isDataParsed}
          skeletonComponent={<FieldSkeleton />}
          component={
            <Role
              language={locale}
              currentSelectedValue={roleValue}
              labelText={roleLabel}
              onSelectedValueChanged={(e: any) => onValueChange(e, 'roleValue')}
              environment={env}
              {...roleProps}
            />
          }
        />
      </Box>
      {!isCompanyHidden && (
        <Box pb={4}>
          <ConditionalRender
            isLoading={isLoading}
            skeletonComponent={<FieldSkeleton />}
            component={
              <CompanyInput
                id="companyInput"
                label={companyLabel}
                onBlurCallback={null}
                onChange={(e: any) => onValueChange(e, 'companyValue')}
                value={companyValue}
                {...companyProps}
              />
            }
          />
        </Box>
      )}
      <Box pb={4}>
        <ConditionalRender
          isLoading={isLoading}
          skeletonComponent={<LabelSkeleton />}
          component={
            <Link href={linkUrl} target="_blank">
              <Typography variant="caption" fontWeight="regular" component="span">
                {linkText}
              </Typography>
            </Link>
          }
        />
      </Box>
    </>
  ) : (
    <SuccessFields successMessage={successMessage} successTitle={successTitle} />
  );

export default Fields;
